
import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Grid, Typography, IconButton, FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { GoArrowDownLeft } from "react-icons/go";
import { Project } from '../../model/project.model';
import { GetAllProjectPerUser } from '../../api/user.api';
import MoreStatus from '../project/moreStatus';



const Graph = () => {
  const [projects, setProjects] = useState<Project[]>([]);
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);
  const [endDate, setEndDate] = useState<string>("");
  const [open, setOpen] = useState(false);
     const userRole = sessionStorage.getItem("userType");
 
  useEffect(() => {
    getProject();
  }, []);

  const getProject = async () => {
    try {
      const userId = sessionStorage.getItem('userId');
      
      if (userId) {
        const projectPerCustomer = await GetAllProjectPerUser(userId);
        console.log("Projects:", projectPerCustomer);
        if (projectPerCustomer.length > 0) {
          setProjects(projectPerCustomer)
          setSelectedProject(projectPerCustomer[0]);
          const dateObject = new Date(projectPerCustomer[0].endDate);
          setEndDate(dateObject.toISOString().split('T')[0]);
        }
      }
    } catch (error) {
      console.error("Failed to fetch projects:", error);
    }
  };
  const handleChangeProject = (event: SelectChangeEvent<string>) => {
    const projectId = event.target.value as string;
    const project = projects.find(proj => proj.projectId === projectId) || null;
    setSelectedProject(project);
    if (project) {
      const dateObject = new Date(project.endDate);
      setEndDate(dateObject.toISOString().split('T')[0]);
    }
  };

const actions = [ {
      icon: <svg width="80" height="69" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M52.7344 19.9219V28.7109C52.7344 29.9238 51.75 30.9082 50.5371 30.9082C49.3242 30.9082 48.3398 29.9238 48.3398 28.7109V19.9219C48.3398 18.709 49.3242 17.7246 50.5371 17.7246C51.75 17.7246 52.7344 18.709 52.7344 19.9219Z" fill="#002046" />
        <path d="M61.5234 15.5273V28.7109C61.5234 29.9238 60.5391 30.9082 59.3262 30.9082C58.1133 30.9082 57.1289 29.9238 57.1289 28.7109V15.5273C57.1289 14.3145 58.1133 13.3301 59.3262 13.3301C60.5391 13.3301 61.5234 14.3145 61.5234 15.5273Z" fill="#0084FF" />
        <path d="M70.3125 11.1328V28.7109C70.3125 29.9238 69.3281 30.9082 68.1152 30.9082C66.9023 30.9082 65.918 29.9238 65.918 28.7109V11.1328C65.918 9.91992 66.9023 8.93555 68.1152 8.93555C69.3281 8.93555 70.3125 9.91992 70.3125 11.1328Z" fill="#00CF7F" />
        <path d="M39.5508 6.73828V35.3027L20.9473 34.1309L6.85547 24.9785C11.9004 12.6665 23.8872 4.54102 37.3535 4.54102C38.5664 4.54102 39.5508 5.52539 39.5508 6.73828Z" fill="#FED843" />
        <path d="M70.3125 37.5C70.3125 54.98 56.7393 69.2578 39.5508 70.3857C38.8242 70.4341 38.0918 70.459 37.3535 70.459C31.8618 70.459 26.4946 69.1011 21.7061 66.5142L26.0859 48.6328L39.5508 35.3027H68.1152C69.3281 35.3027 70.3125 36.2871 70.3125 37.5Z" fill="#002046" />
        <path d="M70.3125 37.5C70.3125 54.98 56.7393 69.2578 39.5508 70.3857V35.3027H68.1152C69.3281 35.3027 70.3125 36.2871 70.3125 37.5Z" fill="#00CF7F" />
        <path d="M39.5508 35.3026C38.0631 37.9048 21.405 67.0401 20.5811 68.4814C19.9365 69.5126 18.5786 69.8217 17.5518 69.1786C6.88769 62.4989 0 50.6996 0 37.4999C0 33.4599 0.641602 29.4843 1.90723 25.6845C2.29102 24.5346 3.53613 23.9106 4.6875 24.2943C4.71108 24.3018 39.2395 35.2044 39.5508 35.3026Z" fill="#0084FF" />
        <path d="M75 28.7109C75 29.9238 74.0156 30.9082 72.8027 30.9082H46.1426C44.9297 30.9082 43.9453 29.9238 43.9453 28.7109C43.9453 27.498 44.9297 26.5137 46.1426 26.5137H72.8027C74.0156 26.5137 75 27.498 75 28.7109Z" fill="#002046" />
      </svg>

      , label: 'גרף נתוני לידים', link: "/dashboardStatus"
    },


    {
      icon: <svg width="80" height="69" viewBox="0 0 103 104" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M92.6561 13.1111H10.344C7.92315 13.1111 5.94238 15.1111 5.94238 17.5555V78.2221H97.2779V17.5555C97.0578 15.1111 95.077 13.1111 92.6561 13.1111Z" fill="#B2C0CD" />
        <path d="M90.6753 19.7776H12.5449V71.5553H90.6753V19.7776Z" fill="white" />
        <path d="M103 78.2222H0C0 85.1111 5.50221 90.8888 12.5449 90.8888H90.6753C97.4978 90.8888 103 85.3332 103 78.2222Z" fill="#2B4C74" />
        <path d="M62.0642 83.5555H40.936L38.5151 78.2222H64.4851L62.0642 83.5555Z" fill="#BCC0C5" />
        <path d="M36.3141 56H29.0513V65.7777H36.3141V56Z" fill="#002046" />
        <path d="M49.0792 42.6667H41.8164V65.5557H49.0792V42.6667Z" fill="#00CF7F" />
        <path d="M61.6239 50.2224H54.3611V65.5557H61.6239V50.2224Z" fill="#0084FF" />
        <path d="M74.3888 38.6667H67.126V65.5557H74.3888V38.6667Z" fill="#002046" />
        <path d="M75.9295 25.7776L73.0683 36.4443L70.4273 33.7776L58.5427 45.7776C57.8824 46.4443 56.7821 46.4443 56.1218 45.7776L46.4381 35.9999L29.2715 53.3332L26.8506 50.8888L45.1176 32.4445C45.7779 31.7778 46.8782 31.7778 47.5385 32.4445L57.2222 42.2222L68.0064 31.3332L65.3654 28.6665L75.9295 25.7776Z" fill="#002046" />
      </svg>

      , label: 'תצוגת גרפים למשימות', link: "/tasksGraph"
    },];

return (
    <div>
      <div className='div'>
      </div>
      <Box sx={{
        padding: 11,
        maxWidth: '1300px',
        margin: '0 auto',
        width: "100%",
        height: "107%"
      }}>
        <Typography
          sx={{
            marginBottom: 0,
            textAlign: 'right',
            fontSize: '28px',
            fontWeight: 700,
            fontFamily: 'CustomFont',
            lineHeight: '48px',
            '@media (max-width: 600px)': {
              marginBottom: "30px",
              fontSize: '22px !important', /* גודל קטן יותר למובייל */
            },
          }}
        ></Typography>
        <Grid container spacing={2} marginTop={"5%"} marginBottom={"5%"}>
          {actions.map((action, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Link to={action.link} style={{}}>
                <Card className='card' sx={{
                  borderRadius: '15px',
                  width: '100%',
                  height: '107%',
                  textAlign: 'center',
                  padding: 2,
                  '@media (max-width: 600px)': {
                    padding: 1,
                  }
                }}>
                  <IconButton>
                    {action.icon}
                  </IconButton>
                  <CardContent>
                    <Typography variant="body1" sx={{ display: 'inline-block', marginLeft: '8px', fontWeight: 700, fontSize: "22px" }} className='label'>
                      <GoArrowDownLeft className='arrow' />
                      {action.label}
                    </Typography>
                  </CardContent>
                </Card>
              </Link>
            </Grid>
          ))}
        </Grid>
      </Box>
      {/* </Box> */}
    </div>
  );
}



export default Graph;


